import Icons from "../svg/Icons.ts";
import * as modal from  "../util/modal.ts";
import * as amplify from "../util/amplify.ts";
import * as i18n from "../i18n.ts";
import ApiServer from "../ApiServer.ts";

import * as FwDatas from "../FwDatas.ts";
import { TaskCache } from "../server/objects/TaskBeans.ts";
import { notadminmodal } from "../global_connected.ts";


export async function checkTaskLimitOntry(wannaAddCount=1){
  var
    allTasks = await TaskCache.need(),
    count = allTasks.length,
    limit = FwDatas.getState().premium.technicalLimitTask;

  if(count+wannaAddCount>limit){
    return false;
  }
  return true;
}
var limitShown = false;
export async function checkTaskSoftLimit(){
  if(limitShown) return;
  var
    allTasks = await TaskCache.need(),
    count = allTasks.length,
    limit = FwDatas.getState().premium.technicalLimitTask;

  if(count>0.8*limit){
    limitShown = true;
    taskSoftLimitReach()
    return true;
  }
  return false;
}


function taskSoftLimitReach(){
  modal.toast({
    text:"listclean.softlimittoast",
    onclick:softLimitReachModal
  })
}

function softLimitReachModal(){
  modal.askAsPromise({
    title:'listclean.softlimitmodaltitle',
    svg:Icons.list.cleanup_alert,
    mediaSize:100,
    message:"listclean.softlimitmodalmessage",
    button:[
      {title:"actions.gotit"}
    ]
  })
}
export function taskHardLimitReach(currentListId :string){
  modal.toast({
    text:"listclean.hardlimittoast",
    async onclick(){
      var
        {complete,ids,makeCall,notadmin} = deletableStatus(currentListId);
      if(notadmin){
        return notadminmodal()
      }  
      var response = await modal.askAsPromise({
        title:'listclean.hardlimitmodaltitle',
        svg:Icons.list.cleanup_alert,
        mediaSize:100,
        message:"listclean.hardlimitmodalmessage",
        button:complete>0?[
          {title:"catsystem.clean",value:"true",class:"negative"},
          {title:"actions.later",class:"secondary"},
        ]:[
          {title:"actions.gotit"},
        ]
      })
      if(response==='true'){
        taskdeletemarkedraw(currentListId)
      }
    }
  })
}

function deletableStatus(listId : string) : {complete:number,ids:string[],makeCall:boolean,notadmin:boolean}{
  var
    list = FwDatas.get(listId),
    ids = list.complete.filter(function(task){return task.editable}).map(task => task.metaId);

  return {
    complete : list.complete.length,
    ids,
    makeCall:ids.length>0,
    notadmin:ids.length<list.complete.length
  }
}

export async function taskdeletemarkedraw(metaId :string){
  var
    {complete,ids,makeCall,notadmin} = deletableStatus(metaId);

  if(makeCall){
    if(!await modal.confirmDelete({
      title:"catsystem.deletecompletedtitle",
      message:i18n.get('catsystem.deletecompletedconfirm',ids.length)
    })){
      return;
    }
    var deleted = ApiServer.metadelete(ids);
    amplify.publish("taskNeedRefresh");
    await deleted;
    if(notadmin){
      modal.alert("catsystem.alertnotalldeleted")
    }
  }else if(notadmin){
    modal.alert("catsystem.alertnotalldeleted")
  }
  modal.toast({text:i18n.get('listclean.deletedtoast',ids.length)})
}